import api from '.';
import downloadFile from '../functions/downloadFile';

interface QueryGetProjectDocumentVersionFile {
  projectDocumentVersionFileId: number;
  contentType: string;
  filename: string;
  isDownload?: boolean;
  isPreview?: boolean;
}

interface QueryGetProjectDocumentVersionFilePreview
  extends Omit<QueryGetProjectDocumentVersionFile, 'isDownload' | 'isPreview'> {
  actionDate: Date;
}

interface QueryGetProjectDocumentVersionFileWithWaterMark
  extends Omit<QueryGetProjectDocumentVersionFile, 'isDownload' | 'isPreview'> {
  positions: string[];
  rotations: number[];
  colors: string[];
  actionDate: Date;
}

interface QueryGetProjectDocumentVersionFileAnnotation
  extends Omit<
    QueryGetProjectDocumentVersionFile,
    'projectDocumentVersionFileId'
  > {
  projectDocumentVersionFileAnnotationId: number;
}

export async function getProjectDocumentVersionFileInfo(
  projectDocumentVersionFileId: number
) {
  const { data } = await api.get(
    `/project-document-version-files/${projectDocumentVersionFileId}/info`
  );
  return data;
}

export async function getProjectDocumentVersionFile({
  projectDocumentVersionFileId,
  contentType,
  filename,
  isDownload = true,
  isPreview = false
}: QueryGetProjectDocumentVersionFile): Promise<void> {
  const { data } = await api.get(
    `/project-document-version-files/${projectDocumentVersionFileId}`,
    { responseType: 'blob' }
  );
  downloadFile({ data, contentType, filename, isDownload, isPreview });
}

export async function getProjectDocumentVersionFilePreview({
  projectDocumentVersionFileId,
  contentType,
  filename,
  actionDate
}: QueryGetProjectDocumentVersionFilePreview) {
  const params = { actionDate };
  const { data } = await api.get(
    `/project-document-version-files/${projectDocumentVersionFileId}/preview`,
    { responseType: 'blob', params }
  );
  downloadFile({
    data,
    contentType,
    filename,
    isDownload: false,
    isPreview: true
  });
}

export async function getProjectDocumentVersionFileWithWaterMark({
  projectDocumentVersionFileId,
  contentType,
  filename,
  positions,
  rotations,
  colors,
  actionDate
}: QueryGetProjectDocumentVersionFileWithWaterMark) {
  const params = {
    positions,
    rotations,
    colors,
    actionDate
  };
  const { data } = await api.get(
    `/project-document-version-files/${projectDocumentVersionFileId}`,
    { responseType: 'blob', params }
  );
  downloadFile({
    data,
    contentType,
    filename,
    isDownload: true,
    isPreview: false
  });
}

export async function getProjectDocumentVersionFileBlob({
  projectDocumentVersionFileId,
  contentType,
  filename
}: {
  projectDocumentVersionFileId: number;
  contentType: string;
  filename: string;
}) {
  const params = { actionDate: new Date() };
  const { data } = await api.get(
    `/project-document-version-files/${projectDocumentVersionFileId}/preview`,
    { responseType: 'blob', params }
  );
  return { blob: data, contentType, filename };
}

export async function getProjectDocumentVersionFileAnnotationLink(
  projectDocumentVersionFileId: number
) {
  const { data } = await api.get(
    `/project-document-version-files/${projectDocumentVersionFileId}/annotation`
  );
  window.open(data.redirectURL, '_blank');
}

export async function getProjectDocumentVersionFileAnnotation({
  projectDocumentVersionFileAnnotationId,
  contentType,
  filename,
  isDownload = true,
  isPreview = false
}: QueryGetProjectDocumentVersionFileAnnotation) {
  const { data } = await api.get(
    `${process.env.REACT_APP_ANNOTATION_URL}/document/${projectDocumentVersionFileAnnotationId}/export`,
    { responseType: 'blob' }
  );
  downloadFile({ data, contentType, filename, isDownload, isPreview });
}
